import AbstractDecimalAmount from "./AbstractDecimalAmount";

class DecimalForConceptos extends AbstractDecimalAmount {
  static decimales = 2;

  static make(number) {
    return new this(number, DecimalForConceptos.decimales)
  }
}

export default DecimalForConceptos;